// The business behind Gatherly, shown in the footer, the policies and at
// checkout. PayFast and South African consumer law (ECTA s43) require the
// registered name, registration number and contact details on the website.
//
// Fields left as null are not filled in yet; pages show them as missing.
export const COMPANY = {
  tradingName: "Gatherly",
  legalName: "defyWorld",
  registrationNumber: "2020/161221/07",
  email: "defyappsonline@gmail.com",
  phone: null, // e.g. "+27 11 000 0000"
  address: null, // physical address, e.g. "12 Main Road, Sandton, Johannesburg, 2196"
  website: "https://gatherlyinvite.com",
  // Policies take effect from this date; change it whenever they change.
  policiesUpdated: "2026-11-02",
};

export const missing = (value) => value || "[to be confirmed]";
